import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class cognitoTokenService {
  constructor(private http: HttpClient) { }

  async getToken(): Promise<string> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'x-api-key': environment.apiKey
    });

    try {
      const response: any = await this.http.post(environment.COGNITO_TOKEN_URL, {}, { headers }).toPromise();

      // La respuesta tiene el token dentro de un string JSON en el campo body
      if (response && response.body) {
        const bodyData = JSON.parse(response.body);
        return bodyData.access_token;
      } else {
        throw new Error('Respuesta inválida del servicio de token');
      }
    } catch (error) {
      if (!environment.production) {
        console.error('Error obteniendo token:', error);
      }
      throw error;
    }
  }
}
